// src/App.jsx
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppContent from './AppContent';
import { Buffer } from 'buffer';

// Polyfill para Buffer - más robusto
try {
  if (typeof window !== 'undefined' && !window.Buffer) {
    window.Buffer = Buffer;
  }
} catch (error) {
  console.warn('Error setting up Buffer polyfill:', error);
}
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
